export function titleOf(c) {
  if (c.title) return c.title;
  if (c.titre) return c.titre;
  if (c.name) return c.name;
  if (c.fileName) return c.fileName;
  if (c.filePath) return String(c.filePath).split("/").pop();
  if (c.fileUrl) {
    try { return decodeURIComponent(String(c.fileUrl).split("?")[0]).split("/").pop(); }
    catch { return "Sans titre"; }
  }
  if (c.url) {
    try { return decodeURIComponent(String(c.url).split("?")[0]).split("/").pop(); }
    catch { return "Sans titre"; }
  }
  return "Sans titre";
}

export function extOf(c) {
  const name = (titleOf(c) || "").toLowerCase();
  const path = (c.storagePath || c.filePath || "").toLowerCase();
  const url  = (c.url || c.fileUrl || "").toLowerCase();
  const key  = (c.r2Key || "").toLowerCase();
  const from = name || key || path || url;
  const m = from.match(/\.(pdf|mp4|webm|mov|m4v|mp3|wav|png|jpe?g|gif)$/i);
  return m ? m[1] : "";
}

export const R2_HOST = "https://videos.educapsules.com";
export const r2UrlFromKey = (key) => `${R2_HOST}/v/${encodeURIComponent(key)}`;
